import React, { useEffect } from 'react';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import LoadingIndicator from '@wix/da-shared-react/pkg/LoadingIndicator';
import { BiLoggerContextProvider } from '@wix/da-bi/pkg/BiLogger.context';
import { OverlayContextProvider } from '@wix/da-react-context/pkg/OverlayContext';
import GallectionSimpleView from './GallectionSimpleView';
import GallectionSearchView from './GallectionSearchView';
import GallectionEmptyState from './GallectionsEmptyState';
import { GallectionType } from '../../../../types/gallection';

export interface Props {
  isSectionLoading: boolean;
  hasAnyDeviations: boolean;
  searchQuery: string;
  gallectionType: GallectionType;
}

const GallectionsSection: React.FC<Props> = ({
  isSectionLoading,
  hasAnyDeviations,
  searchQuery,
  gallectionType,
}) => {
  // we don't do route parsing for gallery using react-router anymore
  // so make the back button simply reload the URL it returns to
  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }
    const reloadWindow = () => window.location.reload();
    window.addEventListener('popstate', reloadWindow);
    return () => {
      window.removeEventListener('popstate', reloadWindow);
    };
  }, []);

  const browsev2_mobile_thumbs_watch_button = useFlag(
    'browsev2_mobile_thumbs_watch_button'
  );

  if (isSectionLoading) {
    return <LoadingIndicator />;
  }

  if (!hasAnyDeviations) {
    return <GallectionEmptyState />;
  }

  const view = searchQuery ? (
    <GallectionSearchView />
  ) : (
    <BiLoggerContextProvider value={{ sectionname: gallectionType }}>
      <GallectionSimpleView />
    </BiLoggerContextProvider>
  );

  return browsev2_mobile_thumbs_watch_button ? (
    <OverlayContextProvider value={{ showAuthorWatchButton: false }}>
      {view}
    </OverlayContextProvider>
  ) : (
    view
  );
};
GallectionsSection.displayName = 'GallectionsSection';

export default GallectionsSection;
